import React, { useMemo, useEffect, useState } from 'react';
import { Box, Container, Typography, Fab, Stack, Chip } from '@mui/material';
import ReactMarkdown from 'react-markdown';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';

export default function AboutPage() {
  const navigate = useNavigate();
  const [content, setContent] = useState('');

  const readingTime = useMemo(() => {
    const words = content.split(/\s+/).filter(Boolean).length;
    return Math.max(1, Math.round(words / 200));
  }, [content]);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const el = document.querySelector('#about-top');
      if (el) el.focus();
    }
  }, []);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await fetch('/about_content.md');
        const text = await res.text();
        setContent(text);
      } catch (e) {
        setContent('# About Trade-Vue\n\nFailed to load content.');
      }
    };
    load();
  }, []);

  return (
    <Box sx={{ position: 'relative' }}>
      <Fab color="primary" aria-label="Back to Practice" onClick={() => navigate('/')} sx={{ position: 'fixed', bottom: 24, right: 24, zIndex: 1500 }}>
        <ArrowBackIcon />
      </Fab>
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Box id="about-top" tabIndex={-1}>
          <Typography variant="h2" gutterBottom>About Trade-Vue: The Science of Pattern Recognition Training</Typography>
          <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 2 }}>
            <Chip label={`Estimated reading time: ${readingTime} min`} color="default" variant="outlined" />
          </Stack>

          <Box sx={{ '& h1, & h2, & h3': { mt: 3 }, '& p': { fontSize: 16, lineHeight: 1.7 } }}>
            <ReactMarkdown>{content}</ReactMarkdown>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}


